export const SHOW_ASSET_FORM = 'SHOW_ASSET_FORM'
export const HIDE_ASSET_FORM = 'HIDE_ASSET_FORM'
export const SET_OPTIONS = 'SET_OPTIONS'
export const SHOW_PRINT_LABEL = 'SHOW_PRINT_LABEL'
export const HIDE_PRINT_LABEL = 'HIDE_PRINT_LABEL'
export const SHOW_MAINTENANCE = 'SHOW_MAINTENANCE'
export const HIDE_MAINTENANCE = 'HIDE_MAINTENANCE'
export const SHOW_MAINTENANCE_RECORD = 'SHOW_MAINTENANCE_RECORD'
export const HIDE_MAINTENANCE_RECORD = 'HIDE_MAINTENANCE_RECORD'